import { getLocale } from "../runtime";

const sv_bgcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Bulgarien`
};

const bgcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_bgcountry(inputs)
	return "bgCountry";
};

export { bgcountry as "bgCountry" };